export const blockIconsToggleStarHalf = (
	<span className='material-symbols-outlined'>star_half</span>
);
